// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Hzxw","notes":"Notes_notes__1E7ma"};